import { pageFetchPosters, pageGetNextPageHref } from "./page.js";
import {
  postersExcludePoster,
  postersEscapeSpacesAndApostrophes,
  postersGetDateString,
  postersGetEndDateOrTime
} from "./posters.js";

function linksCreateAndAppend(poster, parent) {
  let relativeLink =
    encodeURIComponent(postersEscapeSpacesAndApostrophes(poster.id)) +
    ".html?id=" +
    poster.publisherId;

  let template =
    "<div class='posterListBlock'>" +
    "<div class='posterListDate'>" +
    postersGetDateString(poster.dateBegin) +
    " " +
    postersGetEndDateOrTime(
      poster.dateBegin,
      poster.dateEnd,
      poster.timeBegin
    ) +
    "</div>" +
    "<div class='posterListTitle'>" +
    "<a href='/" +
    relativeLink +
    "'>" +
    poster.title +
    "</a>" +
    "</div>";

  if (poster.subtitle !== "") {
    template += "<div class='posterListSubtitle'>" + poster.subtitle + "</div>";
  }
  template += "</div>"; // posterListBlock
  template += "<div class='posterLabelWrapper'>";
  poster.labelsList.forEach((value) => {
    template +=
      "<a class='posterLabel' href='/?label=" +
      postersEscapeSpacesAndApostrophes(value) +
      "'>" +
      value +
      "</a>";
  });
  template +=
    "<a class='posterLabel' href='/map.html?lat=" +
    poster.latitude +
    "&lng=" +
    poster.longitude +
    "&zoom=15'>" +
    poster.town +
    "</a>";

  template +=
    "<a class='posterLabel' href='/?region=" +
    postersEscapeSpacesAndApostrophes(poster.region) +
    "'>" +
    poster.region +
    "</a>";

  template += "</div>"; // posterLabelWrapper

  template +=
    "<div id='posterSocial'>" +
    "<div style='margin-bottom: 1em;'>Gràcies per compartir-ho" +
    "</div>" +
    "<div class='fb-like' data-width='' data-layout='button_count' data-action='like' data-size='large' data-share='true' data-href='https://cartells.elmolideponent.com/" +
    relativeLink +
    "'></div></div>";

  let wrapper = document.createElement("div");
  wrapper.innerHTML = template;
  wrapper.setAttribute("class", "posterListWrapper");

  parent.appendChild(wrapper);

  return wrapper;
}

function linksCreate(parentId) {
  let parent = document.getElementById(parentId);

  let posterWrapper = document.getElementsByClassName("posterWrapper")[0];

  postersExcludePoster(
    posterWrapper.getAttribute("data-author-id"),
    posterWrapper.getAttribute("data-post-id")
  );

  // postersFetchAPoster(linksCreateAndAppend, parent);
  // postersFetchAPoster(linksCreateAndAppend, parent);
  // postersFetchAPoster(linksCreateAndAppend, parent);

  // let linksFlush = mainSetGetLabelCookie(null, "flush");
  // postersSetFlushValue(linksFlush);

  pageFetchPosters(parent, "", "", "", 0).then((isThereMorePosters) => {
    if (isThereMorePosters === true) {
      document.getElementById("posterNextPageButtonWrapper").style.display =
        "block";
      document
        .getElementById("posterNextPageButton")
        .setAttribute("href", pageGetNextPageHref());
    } else {
      document.getElementById("posterNextPageButtonWrapper").style.display =
        "none";
    }
  });
}

export { linksCreate, linksCreateAndAppend };
